import script from "./psiGoodsOutStoreOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./psiGoodsOutStoreOrder.vue?vue&type=script&setup=true&lang=js"

import "./psiGoodsOutStoreOrder.vue?vue&type=style&index=0&id=08b08808&scoped=true&lang=css"

import exportComponent from "E:\\zanbiya\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08b08808"]])

export default __exports__